import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import { useJwt } from "react-jwt";
import { GetOrderById } from '../apiconfig/authService';

function ViewOrder() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [mediaData, setMediaData] = useState([]);
    const { mediaid } = useParams();
    const [orderData, setOrderData] = useState([]);
    const { orderid } = useParams();

    console.log("Order data ", orderData);

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetOrderById(orderid, localStorage.getItem('accessToken'));
                    setOrderData(response.data);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);


    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Order Management</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/order" className="btn btn-primary addSeller"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                    </div>
                </div>
                <div className="detailsBox">
                    <div className="row">
                        <div className="col-lg-6">
                            <h4 className="text-primary h6 fw-bold">Order Information</h4>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>Order ID</th>
                                            <td>{orderData?.order?.orderid}</td>
                                        </tr>
                                        <tr>
                                            <th>Purchased Date</th>
                                            <td>{formatUTCDate(orderData?.order?.purchasedate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Order Price</th>
                                            <td>Rs. {orderData?.order?.price}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h4 className="text-primary h6 fw-bold">Delivery & Billing Address Information</h4>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>Address</th>
                                            <td>{orderData?.addressDetails?.address}</td>
                                        </tr>
                                        <tr>
                                            <th>Landmark</th>
                                            <td>{orderData?.addressDetails?.landmark}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h4 className="text-primary h6 fw-bold">Customer Information</h4>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>Customer Name</th>
                                            <td>{orderData?.customerDetails?.name}</td>
                                        </tr>
                                        <tr>
                                            <th>Customer Phone Number</th>
                                            <td>{orderData?.customerDetails?.customerphone}</td>
                                        </tr>
                                        <tr>
                                            <th>Customer Email Address</th>
                                            <td>{orderData?.customerDetails?.emailid}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <h4 className="text-primary h6 fw-bold">Order Information</h4>
                        <div className="table-responsive">
                            <table className="table table-borderless table-hover">
                                <thead>
                                    <tr>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col" width="80">
                                            <div className="tableHeadItems position-relative">
                                                <span className="text-ellipsis">SR.</span>
                                                <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                            </div>
                                        </th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                            <div className="tableHeadItems position-relative">
                                                <span className="text-ellipsis">Product ID</span>
                                                <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                            </div>
                                        </th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                            <div className="tableHeadItems position-relative">
                                                <span className="text-ellipsis">Product Name</span>
                                                <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                            </div>
                                        </th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                            <div className="tableHeadItems position-relative">
                                                <span className="text-ellipsis">Product Image</span>
                                                <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                            </div>
                                        </th>
                                        <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                            <div className="tableHeadItems position-relative">
                                                <span className="text-ellipsis">Purchased Qty</span>
                                                <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="table-group-divider">
                                    {
                                        orderData.productDetails?.map((item, index) => (
                                            <tr key={item.product?._id}>
                                                <td>{index + 1}</td>
                                                <td>{item.product?.productid}</td>
                                                <td>{item.product?.name}</td>
                                                <td><img width="100" height="100" src={item.product?.imageurl} alt="Product Image" /></td>
                                                <td>{item.quantity}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ViewOrder;